import { z } from 'zod';
export const onboardingCompleteSchema = z.object({
    organizationId: z.string().uuid(),
    admin_email: z.string().email(),
    admin_password: z
        .string()
        .min(8, 'Password must be at least 8 characters')
        .regex(/[A-Z]/, 'Password must include an uppercase letter')
        .regex(/[a-z]/, 'Password must include a lowercase letter')
        .regex(/\d/, 'Password must include a number')
        .regex(/[^\w\s]/, 'Password must include a special character'),
    admin_first_name: z.string().min(1, 'First name is required').trim(),
    admin_last_name: z.string().min(1, 'Last name is required').trim(),
    onboardingToken: z.string().min(1, 'Onboarding token is required'),
});
